// Restaurangbutiker
export function IntroRb() {
  return (
    <>
      <h2>Martin & Servera Restaurangbutiker</h2>
      <p className="intro-content--p">Handla mat, dryck och köksutrustning i våra butiker i Årsta och Bromma. Alla kan handla hos oss och medlemskapet är kostnadsfritt. Vi har generösa öppettider alla dagar. Upptäck vårt stora showroom i Årsta och vår nya utrustningsavdelning i Bromma.</p>
      <p className="intro-content--p">Vi ses i butiken – där proffsen handlar!</p>
    </>
  );
}
